import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.NewsletterForm = class NewsletterForm extends Snappy.BaseComponent {
	static get tagName() {
		return 'cw-newsletter-form';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.addEventListeners();
	}

	setVars() {
		this.$form = this.$element.find('.cw-newsletter-form__form');
		this.$messageContainer = this.$element.find('.message-container');
		this.body = this.$element.find('body');
		this.errorClass = 'fa-input-field--error';
		this.messageClass = 'fa-input-field__error-message';
		this.$newsletterForm = $('footer .fa-footer__newsletter__form');
	}

	addEventListeners() {
		this.$form.on('submit', this.onFormSubmission.bind(this));
	}

	onFormSubmission(event) {
	    event.preventDefault();

	    var offersUpdatesFieldVal = false;
	    if ($('#membershipHospitalityUpdatesField') && $('#membershipHospitalityUpdatesField:checked').length !== 0) {
	        offersUpdatesFieldVal = true;
	    }

		var formData = {
			Title: { FieldName : "titleField", FieldValue : $("#emailsignup-title-field :selected").val() },
			FirstName : { FieldName : "firstNameField", FieldValue : $("#name-field").val() },
			LastName : { FieldName : "lastNameField", FieldValue : $("#last-name-field").val() },
			EmailAddress : { FieldName : "emailField", FieldValue : $("#email-field").val() },
			ReceiveOffers: offersUpdatesFieldVal
		};

		$.ajax({
			beforeSend : function (){
				$('.loading-message-wrapper').removeClass('hide').addClass('show');
			},
			url: this.formAction = this.$form.attr('action'),
			method: this.formMethod = this.$form.attr('method'),
			data: this.formData = formData
		})
		.always(this.handleValidationResponse.bind(this));
	}

	handleValidationResponse(response) {
		this.hideAllValidationErrors();
		if (!response.success) {
			$.each(response.fields, (i, field) => {
				if (!field.success) {
					this.showValidationError(field);
				} else {
					this.removeValidationError(field);
				}

				$(".loading-message-wrapper").delay(500).queue(function(next) {
					$(this).removeClass('show').addClass('hide');
					next();
				});
			});
		} else {
			this.handleSuccess(response);
		}
	}

	showValidationError(field) {
		const $element = this.$form.find(`[name=${field.FieldName}]`);

		$element
			.addClass(this.errorClass)
			.parent()
			.addClass(this.errorClass)
			.find(`.${this.messageClass}`).text(field.Reason);
	}

	hideAllValidationErrors()
	{
		$(".fa-input-field--error").each(function() {
			$(this).removeClass("fa-input-field--error");
		});
	}

	removeValidationError(field) {
		const $element = this.$form.find(`[name=${field.element}]`);
		$element
			.removeClass(this.errorClass)
			.parent()
			.removeClass(this.errorClass)
			.find(`.${this.messageClass}`).text('');
	}

	handleSuccess(response) {
		const activeClass = 'active';
		const modalOpen = 'fa-modal--modal-open';

		this.resetForm();
		$(".loading-message-wrapper").delay(500).queue(function(next) {
			$(this).removeClass('show').addClass('hide');
			next();
		});

		this.$messageContainer.addClass(activeClass);
		this.$body.removeClass(modalOpen);
        this.$newsletterForm.hide();
        if ($(".status-success").length === 0){
            this.$newsletterForm.parent().append('<p class="status-success">Thanks for signing up to the latest news from Club Wembley</p>');
        }

		$.each(response.fields, (i, field) => {
			this.removeValidationError(field);
		});

		window.setTimeout(function() {
			this.$messageContainer.removeClass(activeClass);
		}.bind(this), 10000);
	}

	resetForm() {
		this.$form.find('input, select, textarea').each((i, element) => {
			element.value = '';
		});
	}
};

$(function() {
	new Snappy.Component.NewsletterForm();
});



// WEBPACK FOOTER //
// ./components/cw-newsletterForm/scripts/newsletterForm.js